import { Injectable } from '@angular/core';
import { BaseFacade } from '../base/base.facade';
import { TranslateService } from '@ngx-translate/core';
import { DynamicSchemaFactory } from '../dynamic-schema.factory';
import { AppToken } from '../../../models/app-token';
import { LayoutService } from './layout.service';
import { LayoutStore } from './layout.store';
import { LayoutQuery } from './layout.query';

@Injectable({ providedIn: 'root' })
export class LayoutFacade extends BaseFacade {

  constructor(
    private readonly layoutService: LayoutService,
    layoutStore: LayoutStore,
    layoutQuery: LayoutQuery,
    dynamicSchemaFacto: DynamicSchemaFactory,
    translateService: TranslateService) {
    super(layoutService,
      layoutStore,
      layoutQuery,
      dynamicSchemaFacto.getDynamicSchemaFacade(AppToken.LAYOUT_SCHEMA_NAME),
      translateService,
      AppToken.LAYOUT_SCHEMA_NAME + '-facade'
      );
  }

}
